import { render } from "./CouponContainer.vue?vue&type=template&id=cd70caf4&scoped=true"
import script from "./CouponContainer.vue?vue&type=script&lang=js"
export * from "./CouponContainer.vue?vue&type=script&lang=js"

import "./CouponContainer.vue?vue&type=style&index=0&id=cd70caf4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd70caf4"]])

export default __exports__